<template>
  <i-dx-popup
    :popupVisible="popupVisible"
    :title="'품목추가'"
    @popupCloseButtonClick="closeBtn(false)"
    height="660px"
    minHeight="660px"
    maxHeight="660px"
    width="60vw"
  >
    <template v-slot:grid>
      <v-card width="100%" class="v-application bill-item-select-popup-card" style="padding: 0; display: block; height: 100%">
        <div class="bill-item-select-popup">
          <!-- 좌측: 품목 리스트(기존 그대로) -->
          <div class="bill-item-select-popup__left">
            <i-search-panel :searchPanel="true" style="margin-bottom: 10px"></i-search-panel>

            <DxDataGrid
              id="billItemSelect"
              width="100%"
              height="450px"
              :ref="dxDataGridRef"
              :data-source="gridMain"
              :remote-operations="false"
              :hover-state-enabled="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :row-alternation-enabled="true"
              :column-auto-width="true"
              :show-borders="true"
              :show-row-lines="true"
              :focused-row-enabled="true"
              key-expr="orderId"
              :selection="{ mode: 'multiple', deferred: false }"
              @selection-changed="(e) => onGridSelectionChanged(e)"
            >
              <!-- <DxSelection :select-all-mode="'allPages'" show-check-boxes-mode="always" mode="multiple" /> -->
              <DxColumn data-field="itemNm" data-type="string" alignment="center" width="200px" caption="품목명" :allow-editing="false" />
              <DxColumn data-field="feeName" data-type="string" alignment="center" width="180px" caption="요금제명" :allow-editing="false" />
              <DxColumn data-field="paymentStatusNm" data-type="string" alignment="center" width="100px" caption="상태" :allow-editing="false" />
              <DxColumn
                data-field="paymentAmount"
                data-type="string"
                alignment="right"
                width="120px"
                caption="합계금액"
                :allow-editing="false"
                cell-template="amountCellTemplate"
              />
              <DxColumn
                data-field="supplyAmount"
                data-type="string"
                alignment="right"
                width="120px"
                caption="공급가액"
                :allow-editing="false"
                cell-template="amountCellTemplate"
              />
              <DxColumn
                data-field="taxAmount"
                data-type="string"
                alignment="right"
                width="100px"
                caption="세액"
                :allow-editing="false"
                cell-template="amountCellTemplate"
              />
              <DxColumn data-field="compNm" data-type="string" alignment="center" width="300px" caption="비고" :allow-editing="false" />
              <template #amountCellTemplate="{ data: cellInfo }">
                <div>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
              </template>
              <DxColumn data-field="orderDt" data-type="string" alignment="center" width="200px" caption="주문일자" :allow-editing="false" />
            </DxDataGrid>
          </div>

          <!-- 우측: 선택 요약 카드 -->
          <div class="bill-item-select-popup__right">
            <v-card outlined class="bill-item-select-summary v-application">
              <div class="bill-item-select-summary__content">
                <div class="bill-item-select-summary__title">{{ `선택 요약(${selectedItemSummaries.length}건)` }}</div>

                <div class="bill-item-select-summary__block">
                  <div v-if="selectedItemSummaries.length === 0" class="bill-item-select-summary__empty">선택된 항목이 없습니다.</div>

                  <div v-for="(item, idx) in selectedItemSummaries" :key="item.key || idx" class="bill-item-select-summary__card">
                    <div class="bill-item-select-summary__card-line">
                      <span class="bill-item-select-summary__card-label">비고</span>
                      <span class="bill-item-select-summary__card-value">{{ item.note }}</span>
                    </div>
                    <div class="bill-item-select-summary__card-line">
                      <span class="bill-item-select-summary__card-label">합계금액</span>
                      <span class="bill-item-select-summary__card-amount">{{ item.paymentAmountText }}</span>
                    </div>
                  </div>
                </div>

                <!-- 적용 버튼 위: 전체 누적 합계 -->
              </div>

              <div class="bill-item-select-summary__actions">
                <div class="bill-item-select-summary__totals" v-if="selectedItemSummaries.length > 0">
                  <div class="bill-item-select-summary__totals-line">
                    <span class="bill-item-select-summary__totals-label">합계금액</span>
                    <span class="bill-item-select-summary__totals-value">{{ formatToKoreanWon(selectedTotals.paymentAmount) }}원</span>
                  </div>
                  <div class="bill-item-select-summary__totals-line">
                    <span class="bill-item-select-summary__totals-label">공급가액</span>
                    <span class="bill-item-select-summary__totals-value">{{ formatToKoreanWon(selectedTotals.supplyAmount) }}원</span>
                  </div>
                  <div class="bill-item-select-summary__totals-line">
                    <span class="bill-item-select-summary__totals-label">세액</span>
                    <span class="bill-item-select-summary__totals-value">{{ formatToKoreanWon(selectedTotals.taxAmount) }}원</span>
                  </div>
                </div>
                <v-btn color="primary" elevation="0" large block @click="btnApply">적용</v-btn>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </template>
  </i-dx-popup>
</template>
<script>
import IDxPopup from '@/components/common/iDxPopup.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import iSearchPanel from '@/components/common/iSearchPanel.vue'

// API
import { getPaymentHistory } from '@/api/sojunganManagement/paymentHistory.js'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  components: {
    IDxPopup,
    iSearchPanel,
  },
  props: {
    popupVisible: {
      type: Boolean,
      default: () => false,
    },
    clntId: {
      type: String,
      default: () => '',
    },
    taxType: {
      type: String,
      default: () => 'VAT',
    },
  },
  data() {
    return {
      dxDataGridRef: 'billItemSelectGrid',
      gridMain: [],
      selectedRows: [],
    }
  },
  watch: {
    popupVisible(newVal) {
      if (!newVal) this.selectedRows = []
    },
  },
  created() {},
  activated() {},
  beforeMount() {},
  mounted() {
    getPaymentHistory({ clntId: this.clntId }).then((res) => {
      if (res.success) {
        this.gridMain = res.list
        // if (this.taxType === 'VAT') {
        //   // 일반 세금계산서
        //   this.gridMain = res.list.filter(el => el.paymentKey !== 'REFUND')
        // } else {
        //   // 수정 세금 계산서
        //   this.gridMain = res.list.filter(el => el.paymentKey === 'REFUND')
        // }
      }
    })
  },
  methods: {
    parseAmount(value) {
      if (value === null || value === undefined || value === '') return 0
      const numberValue = parseFloat(value.toString().replace(/,/g, ''))
      return Number.isNaN(numberValue) ? 0 : numberValue
    },
    formatToKoreanWon(value) {
      const numberValue = this.parseAmount(value)
      return numberValue.toLocaleString('ko-KR')
    },

    async onGridSelectionChanged() {
      // DxDataGrid selection-changed 이벤트의 selectedRowsData가
      // allPages/가상 페이지 구성에서 누락될 수 있어, 항상 그리드에서 재조회한다.
      this.selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
    },
    ///////////////////////////////////////
    /*            Grid Event             */
    ///////////////////////////////////////

    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    async btnApply() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      this.vToastifyPrompt(
        this.$t(`품목을 선택 하시겠습니까?`),
        'info',
        (current) => {
          let emitData = []
          let isNegative = this.taxType === 'CVA'
          selectedRows.forEach((el, index) => {
            emitData.push({
              // itemSeq: index + 1,
              year: el.paymentDt.substring(0, 4),
              month: el.paymentDt.substring(5, 7),
              day: el.paymentDt.substring(8, 10),
              // itemName: el.feeName,
              itemName: el.itemNm,
              feeName: el.feeName,
              itemUnit: '',
              itemNum: 1,
              // itemDanga: el.paymentAmount,
              // taxSupprice: el.paymentAmount,
              // taxTaxprice: parseInt(el.paymentAmount * 0.1),
              itemDanga: isNegative ? el.paymentAmount * -1 : el.paymentAmount,
              taxSupprice: isNegative ? parseInt(el.supplyAmount * -1) : parseInt(el.supplyAmount),
              taxTaxprice: isNegative ? parseInt(el.taxAmount * -1) : parseInt(el.taxAmount),
              itemBigo: el.compNm,
              orderId: el.orderId,
              paymentKey: el.paymentKey,
            })
          })
          console.log('ee', emitData)
          this.$emit('popupClose', emitData)
        },
        null,
        true
      )
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    // 팝업 닫기
    closeBtn() {
      this.$emit('popupClose', {})
    },
  },
  computed: {
    selectedItemSummaries() {
      const isNegative = this.taxType === 'CVA'
      return (this.selectedRows || []).map((el, idx) => {
        const note = el?.compNm || ''
        const paymentAmount = this.parseAmount(el?.paymentAmount)
        const normalizedAmount = isNegative ? paymentAmount * -1 : paymentAmount
        return {
          key: el?.paymentKey || el?.orderId ? `${el?.paymentKey || ''}_${el?.orderId || ''}` : `${idx}`,
          note,
          paymentAmountText: `${this.formatToKoreanWon(normalizedAmount)}원`,
        }
      })
    },

    selectedTotals() {
      const isNegative = this.taxType === 'CVA'
      return (this.selectedRows || []).reduce(
        (acc, el) => {
          const paymentAmount = this.parseAmount(el?.paymentAmount)
          const supplyAmount = this.parseAmount(el?.supplyAmount)
          const taxAmount = this.parseAmount(el?.taxAmount)

          acc.paymentAmount += isNegative ? paymentAmount * -1 : paymentAmount
          acc.supplyAmount += isNegative ? supplyAmount * -1 : supplyAmount
          acc.taxAmount += isNegative ? taxAmount * -1 : taxAmount
          return acc
        },
        { paymentAmount: 0, supplyAmount: 0, taxAmount: 0 }
      )
    },
  },
}
</script>

<style scoped>
.bill-item-select-popup-card {
  height: 100%;
  overflow: hidden;
}

.bill-item-select-popup {
  display: flex;
  height: 100%;
}

.bill-item-select-popup__left {
  flex: 3;
  padding: 10px;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.bill-item-select-popup__right {
  flex: 1;
  padding: 10px;
  min-width: 0;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.bill-item-select-summary {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.bill-item-select-summary__content {
  padding: 16px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.bill-item-select-summary__actions {
  padding: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  flex: 0 0 auto;
}

.bill-item-select-summary__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 14px;
}

.bill-item-select-summary__block {
  margin-bottom: 0;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.bill-item-select-summary__label {
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 8px;
}

.bill-item-select-summary__empty {
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.9rem;
}

.bill-item-select-summary__card {
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  background: rgba(25, 83, 243, 0.04);
  margin-bottom: 12px;
}

.bill-item-select-summary__card:last-child {
  margin-bottom: 0;
}

.bill-item-select-summary__card-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.bill-item-select-summary__card-line:last-child {
  margin-bottom: 0;
}

.bill-item-select-summary__card-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.55);
}

.bill-item-select-summary__card-value {
  font-size: 0.95rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  text-align: right;
  word-break: break-word;
}

.bill-item-select-summary__card-amount {
  font-size: 1.05rem;
  font-weight: 800;
  color: #1b53f3;
  letter-spacing: -0.02em;
  text-align: right;
}

.bill-item-select-summary__totals {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(25, 83, 243, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.bill-item-select-summary__totals-line {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.bill-item-select-summary__totals-line:last-child {
  margin-bottom: 0;
}

.bill-item-select-summary__totals-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.55);
}

.bill-item-select-summary__totals-value {
  font-size: 1rem;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.85);
  text-align: right;
}
</style>
